import { useEffect, useState } from "react";
import "./BuildStamp.css";

const API_URL = process.env.REACT_APP_API_URL || "RUNTIME_REPLACE_REACT_APP_API_URL";
const WEB_SHA = process.env.REACT_APP_COMMIT_SHA || "local";
const WEB_BRANCH = process.env.REACT_APP_COMMIT_BRANCH || "";
const WEB_BUILT = process.env.REACT_APP_BUILD_TIME || "";

function shortWhen(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const iso = date.toISOString();
  return `${iso.slice(0, 16).replace("T", " ")}Z`;
}

export default function BuildStamp({ className = "" }) {
  const [api, setApi] = useState(null);

  useEffect(() => {
    if (!API_URL || API_URL.startsWith("RUNTIME_REPLACE_")) return undefined;
    let cancelled = false;
    fetch(`${API_URL}/version`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled && data?.sha) setApi(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const built = shortWhen(WEB_BUILT);
  const title = [
    WEB_BRANCH ? `web branch ${WEB_BRANCH}` : "",
    api?.branch ? `api branch ${api.branch}` : "",
    api?.builtAt ? `api built ${shortWhen(api.builtAt)}` : "",
  ].filter(Boolean).join("\n");

  return (
    <p className={ `build-stamp${className ? ` ${className}` : ""}` } title={ title }>
      web { WEB_SHA }
      { api?.sha ? ` · api ${api.sha}` : "" }
      { built ? ` · ${built}` : "" }
    </p>
  );
}
